<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.promotion.title.promoCode" :small="true" :canGoBack="true"></TopBarBg>
        <PageContent class="flex-auto promotion-detail-layout pb-20" :hasPoweredBy="hasPoweredBy">
            <div v-if="campaign" class="-mt-16">
                <div class="text-center flex justify-center">
                    <div class="inline-block rounded-xl relative">
                        <img class="rounded-xl mx-auto campaign-image block" :src="campaign.fullImageUrl" />
                        <div v-if="campaign.qty < 1" class="disabled-item flex items-center justify-center">
                            <div class="inline-block py-2 px-3.5 rounded-tl-20px rounded-br-20px label-bg">
                                <span class="text-white text-2xl font-medium">{{ lbl.default.soldOut }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-5 pt-6">
                    <section class="header">
                        <div class="brand text-primary-50 text-sm uppercase">{{ campaign.name_brand }}</div>
                        <div class="brand text-primary text-base my-2">{{ campaign.name }}</div>
                        <div class="brand text-gray-secondary text-sm">{{ lbl.default.period }} : {{ getDate() }}</div>
                        <div class="flex items-start gap-1" v-if="campaign.daysValidAfterRedeem > 0">
                            <img class="w-4 h-4 mt-1" src="@/assets/icon/misc/ic-clockcountdown.webp" alt="point" />
                            <div class="brand text-red-1 text-14">{{ getTextAfterUsed() }}</div>
                        </div>
                    </section>
                    <section class="detail mt-4">
                        <VTabNav v-model="tab" :items="tabs" grow @update:modelValue="setTracking($event)"></VTabNav>
                        <VTabItems id="tab-campaign-detail" :tab="tab" class="pt-5">
                            <VTabItem v-show="tab == 0" class="flex max-w-full break-words">
                                <div v-html="detailText"></div>
                            </VTabItem>
                            <VTabItem v-show="tab == 1" class="flex max-w-full break-words">
                                <div v-html="conditionText"></div>
                            </VTabItem>
                        </VTabItems>
                    </section>
                    <!-- <section class="actions w-full">
                        <VBtn
                            blocked
                            large
                            variant="primary"
                            @click="showConfirm()"
                        >{{ lbl.redeem_button.default }}</VBtn>
                    </section>-->
                </div>
                <div v-if="errorText !== ''" class="fixed bottom-90px w-full px-5 max-w-600px">
                    <div class="bg-red-2 rounded-lg text-red-1 text-center p-2.5 text-sm">{{ errorText }}</div>
                </div>
                <div class="actions w-full px-5 fixed bottom-0 pb-6 bg-white pt-2.5 max-w-600px">
                    <VBtn v-if="isEnable" blocked large variant="primary" @click="showConfirm()">{{ btnRedeemText }}</VBtn>
                    <VBtn v-else blocked large variant="disable">{{ btnRedeemText }}</VBtn>
                </div>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>

        <VBottomSheet ref="btsConfirm" v-model="bottomSheetConfirm" :persistent="false">
            <div class="absolute right-5 top-6">
                <img src="@/assets/icon/dialog/close.svg" @click="cancelRedeem()" alt />
            </div>
            <div class="px-5 mt-14 text-center relative">
                <img src="@/assets/icon/campaign/icon_confirm_redeem.svg" alt="icon confirm redeem" class="w-20 h-20 mx-auto"/>
                <div class="relative flex flex-col items-center justify-center pt-5">
                    <div class="font-semibold text-2xl text-primary uppercase">{{ lbl.confirm_redeem.default }}</div>
                    <div v-if="!isType8Survey" class="pt-4">
                        <div class="text-xl text-center text-gray-secondary" v-if="campaign.minutesValidAfterUsed > 0">
                            <div v-html="getConfirmRedeemMessage()"></div>
                        </div>
                        <div class="text-xl text-center text-gray-secondary" v-else>
                            {{ lbl.confirm_redeem.default_no_time }}
                        </div>
                    </div>
                </div>
                <div v-if="isType8Survey" class="mt-10px">
                    <div class="text-base text-gray-secondary">{{ confirmDesc }}</div>
                </div>
                <div class="mt-16 mb-8 mx-4">
                    <VBtn blocked large variant="primary" @click="confirmToRedeem()">{{ lbl.confirm_redeem.confirm }}
                    </VBtn>
                </div>
            </div>
            <Footer :hasPoweredBy="false" />
        </VBottomSheet>

        <SerialCodeDialog ref="dialogCode"></SerialCodeDialog>
    </div>
</template>
<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import VTabNav from "@/components/Tab/TabNav.vue"
import VTabItems from "@/components/Tab/TabItems.vue"
import VTabItem from "@/components/Tab/TabItem.vue"
import VBtn from "@/components/Button/VBtn.vue"
import VBottomSheet from "@/components/Dialog/BottomSheet.vue"
import SerialCodeDialog from "@/module/Detail/modal/SerialModal/SerialCodeDialog.vue"
import { DetailController } from '@/module/Detail/controller/DetailController.js';
import { RedeemController } from '@/module/Detail/controller/RedeemController.js';
// mixins
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
// cores
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import { CampaignType } from "@/helper/StaticValue.js";
// helper
// import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
import CacheHelper from '@/helper/CacheHelper.js';
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import Utility from "@/helper/Utility"

export default {
    name: 'PromotionDetailPage',
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, AuthStatusMixin],
    props: {},
    components: {
        TopBarBg,
        PageContent,
        Footer,
        VTabNav,
        VTabItems,
        VTabItem,
        VBtn,
        VBottomSheet,
        SerialCodeDialog,
    },
    emits: [],
    data: function () {
        return {
            isEnable: true,
            hasPoweredBy: false,
            tab: 0,
            bottomSheetConfirm: false,
            detailController: new DetailController(),
            redeemController: new RedeemController(),
            campaign: null,
            trackCategory: 'campaign_detail',
            trackingScreenName: 'hot_promotion_detail',
        }
    },
    computed: {
        errorText: function () {
            if (!this.campaign.isConditionPass && this.campaign.conditionAlertId == 1427) {
                return ''
            }
            if (!this.campaign.isConditionPass) {
                switch (this.campaign.conditionAlertId) {
                    case 0:
                        return this.lbl.redeem_button.default;
                    case 1:
                        return this.campaign.type == CampaignType.Buy ? this.lbl.redeem_button.soldOutBuy : this.lbl.redeem_button.soldOut;
                    case 2:
                        return this.lbl.redeem_button.maxPerPerson;
                    case 3:
                        return this.lbl.redeem_button.redeemCoolDown;
                    case 4:
                        return this.lbl.redeem_button.exceedBuyPointLimitPerday;
                    case 1403:
                        return this.lbl.redeem_button.conditionIsInvalid;
                    case 1409:
                        return this.campaign.type == CampaignType.Buy ? this.lbl.redeem_button.campaignExpiredBuy : this.lbl.redeem_button.campaignExpired;
                    case 1410:
                        return this.campaign.type == CampaignType.Buy ? this.lbl.redeem_button.campaignNotAvailableBuy : this.lbl.redeem_button.campaignNotAvailable;
                    default:
                        return this.lbl.redeem_button.default;
                }
            }
            return '';
        },
        btnRedeemText: function () {
            if (this.campaign != null) {
                /**@type {import("@/core/Campaign/model/CampaignModel").default} */
                const cp = this.campaign
                if (!Utility.isEmptyStr(cp.customCaption)) {
                    return cp.customCaption
                }
            }
            return this.lbl.redeem_button.default
        },
        tabs: function () {
            let items = [this.lbl.promotion.tabs.detail, this.lbl.promotion.tabs.condition]
            // console.log(this.lbl.promotion)
            return items
        },
        detailText: function () {
            if (this.campaign?.detail != null) {
                return Utility.newLineToBr(this.campaign.detail)
            }
            return null
        },
        conditionText: function () {
            if (this.campaign?.condition != null) {
                return Utility.newLineToBr(this.campaign.condition)
            }
            return null
        },
        isType8Survey: function () {
            if (this.campaign != null && this.campaign.type == CampaignType.Interface) {
                if (this.campaign.interfaceDisplay == 'survey') {
                    return true
                }
            }
            return false
        },
        confirmDesc: function () {
            let txt = this.lbl.confirm_redeem.default
            if (this.isType8Survey) {
                txt = this.lbl.promotion.bottomSheet.confirmRedeemDesc
            }
            console.log(txt)
            return txt
        },
    },
    created: function () {
        this.initialIsFromLanding();
    },
    mounted: function () {
        this.tracking.screenName(this.trackingScreenName);
        // this.showCodeDialog()
        window.addEventListener('pageshow', this.onPageShow);
    },
    beforeUnmount: function () {
        window.removeEventListener('pageshow', this.onPageShow);
    },
    methods: {
        onPageShow: function (event) {
            if (event.persisted) {
                this.initialCampaign();
            }
        },
        onSetupModalCompleted: function () {
            this.initialRedeemModal();
        },
        onAccountInit: function () {
            this.initialCampaign();
        },
        initialCampaign: function () {
            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            this.setupDetailController();
        },
        setupDetailController: function () {
            this.loadingModal.show();
            this.detailController.initial(this.campaignConfig).then((campaign) => {
                // Util.log("campaign=> ", campaign);
                this.campaign = campaign;
                this.isEnable = this.campaign.isConditionPass;
                if (!this.campaign.isConditionPass && this.campaign.conditionAlertId == 1427) {
                    this.isEnable = true;
                }
                this.redeemController.initial(this.campaign, this.modalController);
                this.setRedeemEvent();
                // this.onLoadedCampaign();
            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                this.loadingModal.hide();
            });
        },
        setRedeemEvent: function () {
            this.redeemController.onClickRedeem = () => {
                return true;
            };
            this.redeemController.onConfirmRedeem = () => {
                return true;
            };
            this.redeemController.onCancelRedeem = () => {
                return true;
            };
            this.redeemController.onOpenInterface = () => {
                return true;
            };
            this.redeemController.onOpenShipping = () => {
                return true;
            };
            this.redeemController.onSaveShipping = () => {
                return true;
            };
            this.redeemController.onRedeem = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onRedeemSuccess = (data) => {
                // console.log(data)
                if (data.updated_points != null && data.updated_points.points != null) {
                    this.AccountStore.methods.setPoint(data.updated_points.points);
                }
                this.loadingModal.show();
                this.detailController.reinitial().then((campaign) => {
                    this.campaign = campaign;
                    this.isEnable = this.campaign.isConditionPass;
                    if (!this.campaign.isConditionPass && this.campaign.conditionAlertId == 1427) {
                        this.isEnable = true;
                    }
                    this.isLoadedCampaign = false;
                    this.$nextTick(() => {
                        this.isLoadedCampaign = true;
                    });
                }).finally(() => {
                    this.loadingModal.hide();
                });
                return true;
            };
            this.redeemController.onRedeemError = (err) => {
                // console.log(err)
                this.loadingModal.hide();
                this.errorApi(err, true, {
                    title: this.lbl.bottomSheet.sorry
                })
                // this.modalController.alertBottomModal.clearModal().setTitle().setMsg(err.message).show()
                return true;
            };
            this.redeemController.onAddToCart = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onAddToCartSuccess = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCartError = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onRedirect = (path) => {
                this.$router.push(path)
                return true;
            }
        },
        onLoadedCampaign: function () {
        },
        initialIsFromLanding: function () {
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            var formLanding = "";
            try {
                formLanding = JSON.parse(cacheHelper.getCache('isfromlanding'));
                console.log(formLanding);
            } catch (e) {
                formLanding = cacheHelper.getCache('isfromlanding');
            }
            if (formLanding) {
                cacheHelper.removeCache('isfromlanding');
                var backAmount = 0;
                if (formLanding.page == 'interface') {
                    backAmount = -2;
                } else if (formLanding.page == 'other') {
                    backAmount = -1;
                } else if (formLanding.page == 'wodd') {
                    backAmount = -1;
                } else {
                    backAmount = -2;
                }
                console.log(backAmount)
                history.go(backAmount);
            }
        },
        getDate: function () {
            let start = null
            let expire = null

            if (this.campaign.startDate) {
                start = DatetimeHelper.unixTimestampToDate(this.campaign.startDate)
            }

            if (this.campaign.expireDate) {
                expire = DatetimeHelper.unixTimestampToDate(this.campaign.expireDate)
            }

            let outFormat = 'd MMM yy'

            if (start != null && expire != null) {
                return `${DatetimeHelper.dateFullFormat(start, outFormat)} - ${DatetimeHelper.dateFullFormat(expire, outFormat)}`
            } else if (start != null && expire == null) {
                return `${DatetimeHelper.dateFullFormat(start, outFormat)}`
            }
            else if (start == null && expire != null) {
                return `${DatetimeHelper.dateFullFormat(expire, outFormat)}`
            } else {
                return ''
            }

        },
        showConfirm: function () {
            // this.bottomSheetConfirm = true
            let trackAction = this.campaign.type == CampaignType.Ads ? 'click_register' : 'click_redeem'
            let tracking_label = this.campaign.id + '|' + this.campaign.name;
            this.tracking.event(this.trackCategory, trackAction, tracking_label, null);
            this.$refs.btsConfirm.show()
        },
        cancelRedeem: function () {
            // this.bottomSheetConfirm = false
            this.$refs.btsConfirm.hide()
        },
        confirmToRedeem: function () {
            // console.log("confirm to redeem")
            this.$refs.btsConfirm.hide()
            // this.loadingModal.show()
            var selectCampaignId = this.detailController.selectedCampaignId;
            var selectedQuantity = this.detailController.selectedQuantity;
            this.redeemController.clickRedeem(selectCampaignId, selectedQuantity);
            // setTimeout(() => {
            //     this.loadingModal.hide()
            //     this.showCodeDialog()
            // }, 1000);
        },

        showCodeDialog: function () {
            this.$refs.dialogCode.show()
        },

        setTracking: function (selectedIndex) {
            let trackAction = selectedIndex == 0 ? 'view_detail' : 'view_condition';
            let tracking_label = this.campaign.id + '|' + this.campaign.name;
            this.tracking.event(this.trackCategory, trackAction, tracking_label, null);
        },

        getDateAfterUsed: function () {
            let minutes = this.campaign?.minutesValidAfterUsed;
            if (minutes >= 1440) { // 1 day = 1440 minutes
                const days = Math.floor(minutes / 1440);
                // const remainingMinutes = minutes % 1440;
                // const hours = Math.floor(remainingMinutes / 60);
                return days + ' ' + this.lbl.date.days + (days > 1 && this.localeCode == 1033 ? 's' : '');
            } else if (minutes >= 60) { // 1 hour = 60 minutes
                const hours = Math.floor(minutes / 60);
                // const remainingMinutes = minutes % 60;
                return hours + ' ' + this.lbl.date.hours + (hours > 1 && this.localeCode == 1033 ? 's' : '');
            } else {
                return minutes + ' ' + this.lbl.date.minutes + (minutes > 1 && this.localeCode == 1033 ? 's' : '');
            }
        },

        getTextAfterUsed: function() {
            return this.lbl.campaign.minutes_after_redeem.replace('{0}', this.campaign.daysValidAfterRedeem);
        },

        getConfirmRedeemMessage: function () {
            return this.lbl.confirm_redeem.default_after_used_have_time.replace('{0}', this.getDateAfterUsed());
        }
    }
}
</script>

<style lang="scss" scoped>
.campaign-image {
    width: 269px;
    box-shadow: 0 0 10px 0 rgba(23, 55, 127, 0.31);
}
.disabled-item {
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background-color: rgba(0, 0, 0, 0.4);
}
.label-bg {
    background-color: rgba(0, 0, 0, 0.6);
}
.max-w-600px {
    max-width: 600px;
}
// .promotion-detail-layout{
//     padding-bottom: 80px;
// }
</style>
